import { useEffect, useState } from "react";
import CloneTable from "./CloneTable";
import { Link } from "react-router-dom";
import "./cloneApps.css";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { toast } from "react-toastify";

export default function CloneApps() {
  const cloneAppEditPath = "edit-clone-app";  
  const cloneAppListEndpoint = ApiEndpoints.CloneApp.cloneAppView;
  const cloneAppDeleteEndpoint = ApiEndpoints.CloneApp.cloneAppDelete;
  const [data, setData] = useState([]);

  const tableHeader = ["URL"];
  const tbody = ["url"];

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", cloneAppListEndpoint);
      const result = response.data;
      setData(result);
      
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, [])

  const handleDelete = async (url)=>{
    const payload = { url };
      try {
        const response = await ApiRequest("POST", cloneAppDeleteEndpoint, payload);
        if(response.error===false){
          toast.success(response.message)
        }
        dataFetch();
      } catch (error) {
        console.log(error);
      }
  }; 

  return (
    <>
      <div className="header-add-category">
        <h5>Clone Apps</h5>
      </div>
      <div className="add-cloneapp-section">
        <Link className="default-btn" to="/admin/add-clone-app">
          Add Clone App
        </Link>
        <CloneTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={cloneAppEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  )
}
